import { RowColumn } from '../../Containers';
import { Skeleton } from '../../UI';

import { Textarea, TextareaProps } from '../Textarea';
import { Label } from '../Label';

import { cn } from 'styles';

import { WithLabelCommonProps } from './types';
import { forwardRef } from 'react';

export type LabeledTextareaProps = WithLabelCommonProps & TextareaProps;

export const LabeledTextarea = forwardRef<HTMLTextAreaElement, LabeledTextareaProps>(
  (
    {
      containerClassName,
      fullWidth,
      gap = '2',
      orientation = 'vertical',

      label,
      labelClassName,
      labelIcon: LabelIcon,

      loading,
      error,

      ...inputProps
    },
    ref,
  ) => {
    const hasError = !!error;

    return (
      <RowColumn
        orientation={orientation}
        fullWidth={fullWidth}
        className={containerClassName}
        gap={gap}
      >
        {label && (
          <Label className={labelClassName} htmlFor={inputProps.id}>
            {LabelIcon && (typeof LabelIcon === 'function' ? <LabelIcon size={14} /> : LabelIcon)}
            {label}
          </Label>
        )}

        {loading ? (
          <Skeleton height={80} />
        ) : (
          <Textarea
            ref={ref}
            autoComplete="off"
            className={cn(inputProps.className, hasError && 'border-destructive')}
            {...inputProps}
          />
        )}

        {hasError && typeof error == 'string' && (
          <span className="-mt-1 pl-0.5 text-sm text-destructive">{error}</span>
        )}
      </RowColumn>
    );
  },
);

LabeledTextarea.displayName = 'LabeledTextarea';
